module.exports = __webpack_public_path__ + "img/defaultFaceImg.916664e1.png";